import React, { useState } from 'react';
import { ROLES } from '../shared/rolesData';
import { Shield, ShieldAlert, Check } from 'lucide-react';

export default function SectionRollen() {
  const [expanded, setExpanded] = useState(null);

  return (
    <div className="space-y-4" data-testid="section-rollen">
      <div>
        <h3 className="text-base font-bold text-slate-800 mb-1">Rollen &amp; Berechtigungen — 12 Rollen</h3>
        <p className="text-xs text-slate-500">
          Vollständige Liste aller {ROLES.length} System-Rollen. Die Rechte werden zentral in
          <code className="mx-1 px-1 bg-slate-100 rounded">config/seeds/role_permissions.json</code>
          gepflegt und via Admin-UI überschrieben.
        </p>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full text-xs border-collapse">
          <thead>
            <tr className="bg-slate-800 text-white">
              <th className="text-left p-2 font-semibold">Rolle</th>
              <th className="text-left p-2 font-semibold">Scope</th>
              <th className="text-center p-2 font-semibold">2FA Pflicht</th>
              <th className="text-left p-2 font-semibold">Details</th>
            </tr>
          </thead>
          <tbody>
            {ROLES.map((r, i) => (
              <React.Fragment key={r.key}>
                <tr
                  className={`${i % 2 === 0 ? 'bg-white' : 'bg-slate-50'} border-b border-slate-200 cursor-pointer hover:bg-blue-50 transition`}
                  onClick={() => setExpanded(expanded === r.key ? null : r.key)}
                  data-testid={`role-row-${r.key}`}
                >
                  <td className="p-2">
                    <div className="font-semibold text-slate-800">{r.name}</div>
                    <div className="text-[10px] font-mono text-slate-400">{r.key}</div>
                  </td>
                  <td className="p-2 text-slate-600">{r.scope}</td>
                  <td className="p-2 text-center">
                    {r.totpRequired
                      ? <span className="inline-flex items-center gap-1 text-red-600 font-semibold" title="TOTP Pflicht"><ShieldAlert className="w-3 h-3" /> Pflicht</span>
                      : <span className="inline-flex items-center gap-1 text-slate-400"><Shield className="w-3 h-3" /> Optional</span>}
                  </td>
                  <td className="p-2 text-blue-600 font-semibold text-[11px]">
                    {expanded === r.key ? '▲ Schließen' : '▼ Anzeigen'}
                  </td>
                </tr>
                {expanded === r.key && (
                  <tr className="bg-blue-50/50">
                    <td colSpan={4} className="p-3">
                      <div className="text-xs text-slate-700 mb-2">{r.description}</div>
                      <div className="font-semibold text-[11px] text-slate-600 uppercase tracking-wider mb-1">Schlüssel-Berechtigungen</div>
                      <ul className="space-y-0.5">
                        {r.keyPerms.map((p, j) => (
                          <li key={j} className="flex items-start gap-1.5 text-xs text-slate-700">
                            <Check className="w-3 h-3 mt-0.5 text-green-600 flex-shrink-0" /><span>{p}</span>
                          </li>
                        ))}
                      </ul>
                    </td>
                  </tr>
                )}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>

      <div className="p-3 rounded-lg bg-red-50 border-l-4 border-red-400 text-xs text-red-900">
        <strong className="block mb-1">TOTP-Pflicht bei Hoch-Privileg-Rollen:</strong>
        Admin, GBL und ZQM MÜSSEN 2FA einrichten. Ohne TOTP ist der Zugang zum System gesperrt (Redirect zur 2FA-Einrichtung beim ersten Login).
      </div>
    </div>
  );
}
